export default {
  LOCATION_CHANGE: "@@router/LOCATION_CHANGE",
  AJAX_ERROR: "AJAX_ERROR",
  PAGE_VIEW: "PAGE_VIEW",
  FETCH_USER_DONE: "FETCH_USER_DONE",
};



// WEBPACK FOOTER //
// ./assets/shared/constants/actions.js